export enum ApplyStatus {
  /**
   * 待委托方审核
   */
  WAIT_ENTRUST_AUDIT = 0,

  /**
   * 委托方审核不通过
   */
  ENTRUST_AUDIT_FAIL = 1,

  /**
   * 待平台审核
   */
  WAIT_PLATFORM_AUDIT = 2,

  /**
   * 平台审核不通过
   */
  PLATFORM_AUDIT_FAIL = 3,

  /**
   * 平台审核通过
   */
  PLATFORM_AUDIT_SUCCESS = 4,

  /**
   * 待参与方确认
   */
  WAIT_PARTICIPANT_CONFIRM = 5,

  /**
   * 报名成功
   */
  APPLY_SUCCESS = 6,

  /**
   * 禁用
   */
  FORBIDDEN = 7
}

/**
 * 委托方看到的状态文本
 */
export const ApplyStatusEntrustTextMap = {
  [ApplyStatus.WAIT_ENTRUST_AUDIT]: '待审核',
  [ApplyStatus.ENTRUST_AUDIT_FAIL]: '已拒绝报名',
  [ApplyStatus.WAIT_PLATFORM_AUDIT]: '待平台审核',
  [ApplyStatus.PLATFORM_AUDIT_FAIL]: '平台审核不通过',
  [ApplyStatus.PLATFORM_AUDIT_SUCCESS]: '待缴纳保证金',
  [ApplyStatus.WAIT_PARTICIPANT_CONFIRM]: '待接受邀约',
  [ApplyStatus.APPLY_SUCCESS]: '报名成功',
  [ApplyStatus.FORBIDDEN]: '已禁用'
}

/**
 * 平台看到的状态文本
 */
export const ApplyStatusPlatformTextMap = {
  [ApplyStatus.WAIT_ENTRUST_AUDIT]: '待委托方审核',
  [ApplyStatus.ENTRUST_AUDIT_FAIL]: '委托方审核不通过',
  [ApplyStatus.WAIT_PLATFORM_AUDIT]: '待平台审核',
  [ApplyStatus.PLATFORM_AUDIT_FAIL]: '平台审核不通过',
  [ApplyStatus.PLATFORM_AUDIT_SUCCESS]: '待缴纳保证金',
  [ApplyStatus.WAIT_PARTICIPANT_CONFIRM]: '待接受邀约',
  [ApplyStatus.APPLY_SUCCESS]: '报名成功',
  [ApplyStatus.FORBIDDEN]: '已禁用'
}

export const ApplyStatusColorMap = {
  [ApplyStatus.WAIT_ENTRUST_AUDIT]: 'processing',
  [ApplyStatus.ENTRUST_AUDIT_FAIL]: 'error',
  [ApplyStatus.WAIT_PLATFORM_AUDIT]: 'processing',
  [ApplyStatus.PLATFORM_AUDIT_FAIL]: 'error',
  [ApplyStatus.PLATFORM_AUDIT_SUCCESS]: 'processing',
  [ApplyStatus.WAIT_PARTICIPANT_CONFIRM]: 'default',
  [ApplyStatus.APPLY_SUCCESS]: 'success',
  [ApplyStatus.FORBIDDEN]: 'default'
}
